<!-- qesg-dash-card-wrapper -->
<template>
    <b-card class="dash-card shadow-sm" border-variant="0" :no-body="noBody">
        <slot />
    </b-card>
</template>

<script>
export default {
    name: 'qesg-dash-card-wrapper',
    components: {},
    props: {
        noBody: {
            type: Boolean,
            default: false
        }
    },
    computed: {}
}
</script>

<style>

</style>